export const TARGET_PAGES = {
  SUPPORT: 'support',
  FAQ: 'faq'
} as const

export type TargetPageType = (typeof TARGET_PAGES)[keyof typeof TARGET_PAGES]
